import React from 'react';
import { ProductMetafieldsProps } from './types';
import { useBuiltInTranslations } from '../../hooks/useBuiltInTranslations';

const ProductMetafields: React.FC<ProductMetafieldsProps> = ({
  currentProduct,
  getMetafieldValue,
  convertRichTextToHTML,
  isSizeFitExpanded,
  labelShowMore,
  labelShowLess,
  onToggleSizeFit,
}) => {
  const { t } = useBuiltInTranslations();

  if (!currentProduct) return null;

  const materialOrigin = getMetafieldValue('material_origin', 'custom');
  const sizeFit = getMetafieldValue('size_fit', 'custom');

  return (
    <>
      {/* Render material information */}
      {materialOrigin && (
        <div className="metafield-section material-section">
          <h4 className="material-title">{t('materialAndOrigin')}</h4>
          <div
            className="material-content"
            dangerouslySetInnerHTML={{
              __html: convertRichTextToHTML(materialOrigin),
            }}
          />
        </div>
      )}

      {/* Render size & fit information */}
      {sizeFit && (
        <div className="metafield-section size-fit-section">
          <div
            className={`size-fit-content ${isSizeFitExpanded ? 'expanded' : ''}`}
            dangerouslySetInnerHTML={{
              __html: convertRichTextToHTML(sizeFit),
            }}
          />
          <button className="expand-button" onClick={onToggleSizeFit}>
            {isSizeFitExpanded ? labelShowLess : labelShowMore}
          </button>
        </div>
      )}
    </>
  );
};

export default ProductMetafields;
